// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.termsandconditions.RentalManagerUserTermsAndConditionsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserTermsAndConditionsMarkAcceptedTermsRequestWebDto,
  UserTermsAndConditionsMarkAcceptedTermsResponseWebDto,
} from '../..';

export const RentalManagerUserTermsAndConditionsWebApiHandler_markAcceptedTerms_Path =
  '/api/web/v1/users/termsAndConditions/markAcceptedTerms';

/**
 * Mark terms and conditions as accepted
 */
export const RentalManagerUserTermsAndConditionsWebApiHandler_markAcceptedTerms = (
  postData: UserTermsAndConditionsMarkAcceptedTermsRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserTermsAndConditionsMarkAcceptedTermsRequestWebDto,
    UserTermsAndConditionsMarkAcceptedTermsResponseWebDto
  >(
    {
      endpoint: RentalManagerUserTermsAndConditionsWebApiHandler_markAcceptedTerms_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
